import { useParams } from "react-router-dom";
import { FTPBreadCrumbs } from "../../../components-new/BreadCrumbs";
import React from "react";

export const SRCrumbs = (props) => {
  const { projectid } = useParams();
  const crumbs = [
    { name: "DashBoard", href: `/project/${projectid}`, current: true },
    { name: "Service Requests", href: "#", current: true },
  ];
  return (
    <div className="sticky top-[4rem] z-20 [&_nav]:mb-0 [&_nav]:!top-0 [&_nav]:!shadow-none [&_nav]:!border-b-0 [&_nav]:bg-transparent">
      <FTPBreadCrumbs crumbs={crumbs} />
    </div>
  );
};
